"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSmartScheduling = function SvgIconSmartScheduling(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "smart scheduling icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Smart Scheduling Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.75 30.75h10.604a10.921 10.921 0 000 3H9a3 3 0 01-3-3V10.5A1.5 1.5 0 017.5 9h3.375a.75.75 0 01.75.75v3a1.125 1.125 0 002.25 0V7.125a1.125 1.125 0 012.25 0v1.5c0 .207.168.375.375.375h6.375a.75.75 0 01.75.75v3a1.125 1.125 0 002.25 0V7.125a1.125 1.125 0 012.25 0v1.5c0 .207.168.375.375.375h3.75a1.5 1.5 0 011.5 1.5v9.855a10.921 10.921 0 00-3 0V17.25a.75.75 0 00-.75-.75H9.75a.75.75 0 00-.75.75V30c0 .414.336.75.75.75zm22.5-8.25A9.763 9.763 0 0142 32.25c0 5.385-4.365 9.75-9.75 9.75s-9.75-4.365-9.75-9.75 4.365-9.75 9.75-9.75zm4.683 6.23a1.125 1.125 0 00-1.51.145l-.065.08-4.357 5.81-2.25-2.25a1.125 1.125 0 00-1.51-.074l-.082.075a1.13 1.13 0 00-.075 1.51l.075.082 2.25 2.25a2.25 2.25 0 003.306-.13l.087-.108 4.356-5.815a1.125 1.125 0 00-.225-1.575z"
  }));
};

var _default = SvgIconSmartScheduling;
exports.default = _default;